import { DeliveryOption } from '../../pages'

export enum ReportType {
  Online = 'ONLINE',
  Offline = 'OFFLINE'
}

export type SearchReport = {
  code: string | undefined
  bifName: string | undefined
  orderingName: string | undefined
  displayPrice?: string
  lastUpdateDate?: string
  type: ReportType
  materialTypePriceParam?: string
  countryCodePriceParam?: string
  isFinancialPriceParam?: string
  inRevisionPriceParam?: string
  dataTypePriceParam?: string
  deliveryOptions: DeliveryOption[]
  languages: string[]
  consentRequired?: boolean
}

type Address = {
  countryCode?: string
  regionCode?: string
  city?: string
  state?: string
  minorTown?: string
  district?: string
  locationType?: string
  zipCode?: string
  fullAddress?: string
  street?: string
  houseNumber?: string
}

export type SearchCompany = {
  id: string
  matchLevel?: string
  name?: string
  hqAddress?: Address
  legalRepresentative?: string
  contactPhone?: string
  reports?: SearchReport[]
  npwpCode?: string
  legalizationCode?: string
  registrationNumber?: string
  taxId?: string
  enterpriseId?: string
  companyIdentifier: string
  registrationCodes?: string[]
  status?: string
  formerName?: string
  [key: string]: any
}

export type SearchState = {
  companies: SearchCompany[]
  pageSize: number
  pageCount: number
  totalCount: number
}

export type SearchCompaniesResponse = {
  data: {
    companies: SearchCompany[]
  }
  meta: {
    totalCount: number
    pageNumber: number
    pageCount: number
  }
}
